import { Inject, Options, Vue } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import { orderBy } from "lodash";
import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import AppointTrustCoordinatorModal from "./appoint-trust-coordinator-modal/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AppointTrustCoordinatorModal,
  },
  mixins: [
    FormatDateTimeMixin,
  ],
})
export default class PracticePeopleTrustCoordinator extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private searchKeyword = '';
  private showActiveOnly = false;
  private sortMethod = 'asc';
  private activeSortHeader = 0;

  private trustCoordinators: any[] = [];
  private trustCoordinatorsDisplay: any = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  // private directorRequest: IlpDirectorRequest = {};
  private showAppointCoordinatorModal = false;

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: true, sortMethod: 'asc' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Phone number', value: 'phoneNumber', sortable: true, sortMethod: 'asc' },
    { text: 'Email', value: 'email', sortable: true, sortMethod: 'acs' },
    { text: 'From', value: 'effectiveStartDate', sortable: true, sortMethod: 'acs' },
    { text: 'To', value: 'effectiveEndDate', sortable: true, sortMethod: 'acs' },
  ];

  mounted() {
    this.loadTableData();
  }

  private loadTableData() {
    this.loadingContent = true;
    this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(this.selectedPractice.id)
      .then((res: any) => {
        this.trustCoordinators = res.data.data ?? [];
        this.trustCoordinatorsDisplay = this.trustCoordinators;
        for (let i = 0; i < this.trustCoordinators.length; i++) {
          this.trustCoordinatorsDisplay[i].name = this.trustCoordinators[i].firstName + ' ' + this.trustCoordinators[i].lastName;
        }
        this.sortTableColumn(5, true);
        this.loadingContent = false;
      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get Trust Coordinator list: ' + err);
        this.ai.trackException('Error, Unable to get Trust Coordinator list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })

  }

  private reloadTrustCoordinators() {
    this.loadTableData();
  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.trustCoordinators.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.trustCoordinators,
            nameSorter,
            [this.sortMethod as any]
          );
          this.trustCoordinatorsDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any) {
    if (this.searchKeyword == '') return data;
    const _result = data.filter((d: any) => {
      return (d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0) || (d.lawId.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0);
    })
    return _result;
  }

  private isActive(i: any): boolean {
    const _terminatedDate = i.effectiveEndDate ?? null;
    if (_terminatedDate) {
      return false;
    } else {
      return true;
    }
  }

  get disableAppoint(): boolean {
    // If display list effectiveEndDate is null, then disable the appoint button
    const _result = this.trustCoordinatorsDisplay.filter((d: any) => {
      return (d.effectiveEndDate === null);
    })
    return _result.length > 0;
  }

  private addNew() {
    this.showAppointCoordinatorModal = true;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}



